import { jsx as _jsx } from "react/jsx-runtime";
import styles from './FilterMenuItem.module.css';
import Checkbox from '../Checkbox';
import { classNames } from '../../utils';
const FilterMenuItem = ({ id, title, onClick, description = '', checked = false, isCompact = false, highlight = '', }) => (_jsx("li", Object.assign({ className: styles.listWrapper }, { children: _jsx(Checkbox, { checked: checked, className: styles.checkbox, size: 16, onChange: () => onClick(id), fullWidth: true, label: _jsx("span", Object.assign({ className: classNames(styles.title, isCompact ? styles.compactTitle : '') }, { children: getHighlightedText(title, highlight, styles.highlightedText) }), void 0), secondaryLabel: description && (_jsx("span", Object.assign({ className: classNames(styles.description, isCompact ? styles.compactDescription : '') }, { children: getHighlightedText(description, highlight, styles.highlightedText) }), void 0)) }, void 0) }), void 0));
const getHighlightedText = (text = '', highlight, className) => {
    if (!text) {
        return '';
    }
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
    if (!parts) {
        return '';
    }
    return parts.map((part, index) => part.toLowerCase() === highlight.toLowerCase() ? (
    // eslint-disable-next-line react/no-array-index-key
    _jsx("span", Object.assign({ className: className }, { children: part }), `${part}${index}`)) : (part));
};
export default FilterMenuItem;
